import { Component, OnInit, ViewChild } from '@angular/core';
import { InventoryService } from '../../../../services/inventory.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { Paginator } from 'primeng/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { ConfirmationService } from 'primeng/api';
import { NewJobcardService } from '../../../../services/new-jobcard.service';

@Component({
  selector: 'app-inventory-summary',
  templateUrl: './inventory-summary.component.html',
  styleUrls: ['./inventory-summary.component.scss'],
})
export class InventorySummaryComponent implements OnInit {
  public page = 1;
  public limit = 10;
  public search = '';
  public inventoryData: any = [];
  public totalRecords = 0;
  public busy = false;

  public columns: any = [
    {
      header: this.translate.instant('bikeshop.inventory_audit.jobcard_no'),
      field: 'jobCardID',
      type: 'jobcardno',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.customer'),
      field: 'customer',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.bike'),
      field: 'bike',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.sku'),
      field: 'sku',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.product_name'),
      field: 'productName',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.quantity'),
      field: 'quantity',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.stock_changed'),
      field: 'stockChanged',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.action'),
      field: 'action',
      type: 'string',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.date'),
      field: 'createdDate',
      type: 'date',
    },
    {
      header: this.translate.instant('bikeshop.inventory_audit.status'),
      field: 'statusID',
      type: 'status',
    },
  ];

  constructor(
    private inventoryService: InventoryService,
    public helperService: HelpersService,
    private translate: TranslateService,
    public serviceRequest: ServiceRequestService,
    public modalService: NgbModal,
    public router: Router,
    private confirmationService: ConfirmationService,
    private newJobcardService: NewJobcardService,
  ) {}

  @ViewChild('paginator') paginator: Paginator;

  ngOnInit() {
    this.getInventorySummary();
  }

  getInventorySummary() {
    this.busy = true;
    this.inventoryService
      .getInventorySummary(
        this.helperService.getPartnerId(),
        this.page,
        this.limit,
        this.search,
      )
      .subscribe(
        (results) => {
          this.inventoryData = results ? results : [];
          //this.totalRecords = results.totalRecords;
          this.busy = false;
        },
        (err) => {
          this.busy = false;
          this.inventoryData = null;
          this.totalRecords = 0;
        },
      );
  }

  paginate(event) {
    this.page = event.page + 1;
    this.limit = event.rows;
    this.getInventorySummary();
  }

  getStatusDescription(statusID) {
    switch (statusID) {
      case 1:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.unprocessed',
        );
        break;
      case 2:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.error_processing_transaction',
        );
        break;
      case 5:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.being_processed',
        );
        break;
      case 10:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.processed',
        );
        break;
      case 100:
        return this.translate.instant(
          'bikeshop.inventory_audit.statuses.non_inventory_item',
        );
        break;
    }
    return this.translate.instant('bikeshop.inventory_audit.statuses.unknown');
  }

  searchSummary() {
    this.getInventorySummary();
  }

  openJobCard(jobcardID) {

    if (this.helperService.getPartnerData().UseNewJobCard) {
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => { 
          this.getInventorySummary();
        }
      });

      return;
    }

    this.serviceRequest
      .getServiceRequestData(jobcardID)
      .subscribe((jobcard) => {
        const modalRef = this.modalService.open(UpdateJobcardComponent, {
          size: 'lg',
          backdrop: 'static',
          windowClass: 'jobcard-modal',
        });
        modalRef.componentInstance.jobcard = jobcard;
        modalRef.componentInstance.partnerID =
          this.helperService.getPartnerId();
        modalRef.result.then(
          (result) => {
            this.getInventorySummary();
          },
          (onrejected) => {
            this.getInventorySummary();
          },
        );
      });
  }

  sumArray(a) {
    var total = 0;
    for (var i in a) {
      total += a[i];
    }
    return total;
  }

  countOpenJobCards(jobcards) {
    return this.sumArray(
      jobcards
        .filter((x) => {
          return x.ServiceStatusID < 40;
        })
        .map((x) => {
          return x.ActualQuantityAdustment;
        }),
    );
  }

  countCompletedJobCards(jobcards) {
    return this.sumArray(
      jobcards
        .filter((x) => {
          return x.ServiceStatusID >= 40 && x.ServiceStatusID < 50;
        })
        .map((x) => {
          return x.ActualQuantityAdustment;
        }),
    );
  }

  countCollectedJobCards(jobcards) {
    return this.sumArray(
      jobcards
        .filter((x) => {
          return x.ServiceStatusID >= 50 && x.ServiceStatusID <= 55;
        })
        .map((x) => {
          return x.ActualQuantityAdustment;
        }),
    );
  }

  countCancelledJobCards(jobcards) {
    return this.sumArray(
      jobcards
        .filter((x) => {
          return x.ServiceStatusID === 100;
        })
        .map((x) => {
          return x.ActualQuantityAdustment;
        }),
    );
  }

  getOpenJobCards(jobcards) {
    return jobcards.filter((x) => {
      return x.ServiceStatusID < 40;
    });
  }

  getCompletedJobCards(jobcards) {
    return jobcards.filter((x) => {
      return x.ServiceStatusID >= 40 && x.ServiceStatusID < 50;
    });
  }

  getCollectedJobCards(jobcards) {
    return jobcards.filter((x) => {
      return x.ServiceStatusID >= 50 && x.ServiceStatusID <= 55;
    });
  }

  getCancelledJobCards(jobcards) {
    return jobcards.filter((x) => {
      return x.ServiceStatusID === 100;
    });
  }

  openAuditSKU(SKU) {
    window.open('/store/inventory-audit?skusearch=' + SKU, '_blank');
  }

  openAuditSKUJobCardNo(SKU, JobCardNo) {
    window.open(
      '/store/inventory-audit?skusearch=' + SKU + '&jobcardno=' + JobCardNo,
      '_blank',
    );
  }

  buttonEnabled(item) {
    return (
      item.JobCards.filter((x) => {
        return x.selected;
      }).length > 0
    );
  }

  correctHubtigerBalance(item) {
    this.confirmationService.confirm({
      header: this.translate.instant('general.confirm'),
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.no'),
      message: this.translate.instant(
        'bikeshop.inventory_summary.confirm_hubtiger_balance_update',
      ),
      accept: () => {
        item.busy = true;
        item.JobCards.filter((x) => {
          return x.selected;
        }).forEach((jobcard) => {
          var data = {
            InvoiceID: jobcard.InvoiceID,
            InternalProductID: item.InternalProductID,
            ExternalProductID: item.ExternalProductID,
          };
          this.inventoryService
            .updateHubtigerInventoryBalance(
              this.helperService.getPartnerId(),
              data,
            )
            .subscribe((result) => {
              this.inventoryService
                .getInventorySummary(
                  this.helperService.getPartnerId(),
                  this.page,
                  this.limit,
                  item.SKU,
                )
                .subscribe(
                  (results) => {
                    if (results && results.length > 0) {
                      item = results.pop();
                      var skus = this.inventoryData.map((x) => {
                        return x.SKU;
                      });
                      var index = skus.indexOf(item.SKU);
                      this.inventoryData[index] = item;
                    } else {
                      this.getInventorySummary();
                      item.busy = false;
                    }
                  },
                  (err) => {
                    item.busy = false;
                  },
                );
            });
        });
      },
      reject: () => {},
    });
  }

  correctLightSpeedBalance(item) {
    this.confirmationService.confirm({
      header: this.translate.instant('general.confirm'),
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.no'),
      message: this.translate.instant(
        'bikeshop.inventory_summary.confirm_stock_update',
      ),
      accept: () => {
        item.busy = true;
        item.JobCards.filter((x) => {
          return x.selected;
        }).forEach(async (jobcard) => {
          var data = {
            InvoiceID: jobcard.InvoiceID,
            InternalProductID: item.InternalProductID,
            ExternalProductID: item.ExternalProductID,
          };
          this.inventoryService
            .updateLightSpeedInventoryBalance(
              this.helperService.getPartnerId(),
              data,
            )
            .subscribe(
              (result) => {
                this.inventoryService
                  .getInventorySummary(
                    this.helperService.getPartnerId(),
                    this.page,
                    this.limit,
                    item.SKU,
                  )
                  .subscribe(
                    (results) => {
                      if (results && results.length > 0) {
                        item = results.pop();
                        var skus = this.inventoryData.map((x) => {
                          return x.SKU;
                        });
                        var index = skus.indexOf(item.SKU);
                        this.inventoryData[index] = item;
                      } else {
                        this.getInventorySummary();
                        item.busy = false;
                      }
                    },
                    (err) => {
                      item.busy = false;
                    },
                  );
              },
              (err) => {
                alert(err.error.error);
                item.busy = false;
              },
            );
        });
      },
      reject: () => {},
    });
  }
}
